import {SAVE_MERCANCIAS, MercanciaActionTypes} from "../types/mercanciaActionTypes";
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";
import { MercanciaDatosComplementariosActionTypes, SAVE_MERCANCIASCOMPLEMENTARIO } from "../types/mercanciaDatosComplementariosActionTypes";

export function saveMercanciasDatosComplementarios(mercanciasDatosComplementarios: MercanciaDatosComplementarios[]): MercanciaDatosComplementariosActionTypes {
    return{
        type: SAVE_MERCANCIASCOMPLEMENTARIO,
        mercanciasDatosComplementarios
    }
}
